import styled from 'styled-components'

export const FeatureIcon = styled.div<IElement>`
  width: 60px;
  height: 60px;
  flex: 0 0 auto;

  img {
    width: 40px;
    height: 40px;
  }
`

export const FeatureData = styled.div<IElement>`
  flex: auto;

  span {
    display: block;
    line-height: 24px;
  }
`

export const FeatureItem = styled.li<IElement>`
  display: flex;
  font-size: 16px;
  line-height: 24px;
`

export const FeatureWrapper = styled.ul<IElement>`
  box-sizing: border-box;
  width: 100%;
  max-width: 600px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0;
  margin-bottom: 0px;

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`
